(ns machtfit.startpage.clock
  (:require cljs-time.coerce
            cljs-time.core
            [machtfit.api :as api]
            [machtfit.startpage.api-events :as-alias api-events]
            [re-frame.core :as rf]))

(rf/reg-event-fx ::tick-5s
  (fn [{:keys [db]} _]
    (let [diff (-> db :clock :diff-to-server-time)
          tomorrow-start (-> db :server-info :reference-tomorrow-start)
          current-server-time (-> (cljs-time.core/now)
                                  cljs-time.coerce/to-epoch
                                  (+ diff))
          new-day? (and (some? tomorrow-start)
                        (>= current-server-time tomorrow-start))]
      (cond-> {:db (assoc-in db [:clock :current-server-time] current-server-time)}
        new-day? (-> (assoc :post (api/request db
                                               {:data '[(:server-info {} :server-info)]
                                                :on-success #(rf/dispatch [::api-events/api-received %])})))))))

(defn update-server-time [db server-time]
  (update db :clock assoc
          :current-server-time server-time
          :diff-to-server-time (-> (cljs-time.core/now)
                                   cljs-time.coerce/to-epoch
                                   (- server-time))))

#_{:clj-kondo/ignore [:clojure-lsp/unused-public-var]}
(defonce tick-5s-timer-id (js/setInterval #(rf/dispatch [::tick-5s]) 5000))
